/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Hide Menubar",
  "description": "The menubar will hidden and can automatically appear when you hover nearby. You may also choose to lock it in place for persistent display.",
  "tags": ["new",'theme'],
  "credits": [
    {
      "name": "KOSHINO",
      "link": "https://github.com/KOSHINOawa"
    }
  ],
  "enabledByDefault": false,
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "style.css"
    }
  ],
  "info": [
    {
      "type": "notice",
      "text": "Don't enable this addon when you using desktop version.",
      "id": "warn"
    }
  ],
};
export default manifest;
